export enum ExceptionType {
  None,
  CannotProceed,
  ReloadRetry,
  Other,
  DisplayMessage,
}
